import { Dayjs } from 'dayjs'
import { useMediaQuery, useTheme } from '@mui/material'

export const useIsSmallMobile = () => {
  // eslint-disable-next-line no-console
  console.log(Dayjs)
  return useMediaQuery(useTheme().breakpoints.down('sm'))
}

export const useIsMobile = () => {
  return useMediaQuery(useTheme().breakpoints.down('md'))
}

export const useIsTablet = () => {
  return useMediaQuery(useTheme().breakpoints.down('lg'))
}
